import React, { useState, useEffect } from "react";
import VideoSection from "./VideoSection";
import AboutUsSection from "./AboutUsSection";
import ProjectSliderSection from "./ProjectSliderSection";
import ContactSection from "./ContactSection";
import ContactForm from "../Aboutus/ContactForm";
import DisclaimerPage from "../Disclaimer";
import BlogSection from "./BlogSection";
import { Helmet } from "react-helmet-async";

const DashboardPage: React.FC = () => {
  const [acceptedDisclaimer, setAcceptedDisclaimer] = useState(false);
  const [reveal, setReveal] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setReveal(true), 100);
    return () => clearTimeout(timeout);
  }, []);


  const handleDisclaimerAccept = () => {
    setAcceptedDisclaimer(true);
  };

  if (!acceptedDisclaimer) {
    // Render Disclaimer if not accepted
    return <DisclaimerPage onAccept={handleDisclaimerAccept} />;
  }



  const styles = {
    wrapper: {
      position: "relative" as "relative",
      overflow: "hidden",
    },
    blackOverlay: {
      position: "fixed" as "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "black",
      zIndex: 10,
      opacity: reveal ? 0 : 1,
      transition: "opacity 2.5s cubic-bezier(0.22, 1, 0.36, 1)",
      pointerEvents: reveal ? "none" as React.CSSProperties['pointerEvents'] : "auto" as React.CSSProperties['pointerEvents'],
    },
    container: {
      opacity: reveal ? 1 : 0,
      transform: reveal ? "translateY(0)" : "translateY(20px)", // Subtle movement for smoothness
      transition: "opacity 2.5s cubic-bezier(0.22, 1, 0.36, 1), transform 2.5s cubic-bezier(0.22, 1, 0.36, 1)", // Ultra-smooth easing
      zIndex: 1,
      position: "relative" as "relative",
    },
  };

  return (
    <div style={styles.wrapper}>
      <Helmet>

        <title>2.5 & 3 BHK Flats for Sale in Hyderabad | Kolla Group</title>
        <meta name="title" content="2.5 & 3 BHK Flats for Sale in Hyderabad | Kolla Group" />
        <meta name="description" content="Premium 3 BHK flats for sale in Chanda Nagar, Hyderabad. Excellent connectivity to IT hubs & metro. Schedule your site visit with Kolla Group." />
        <meta name="keywords" content="3 BHK flats in Chanda Nagar, 3 BHK flats for sale in Chanda Nagar, 3 BHK flats in Hyderabad, flats for sale in Chanda Nagar Hyderabad, gated community flats in Chanda Nagar, apartments near Miyapur Metro, premium flats in Chanda Nagar, residential projects in Chanda Nagar, ready to move 3 BHK flats Hyderabad, Kolla Group flats" />
        <meta name="author" content="Kolla Group" />
        <link rel="canonical" href="https://kollagroup.com/" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://kollagroup.com/" />
        <meta property="og:title" content="2.5 & 3 BHK Flats for Sale in Hyderabad | Kolla Group" />
        <meta property="og:description" content="Premium 3 BHK flats for sale in Chanda Nagar, Hyderabad. Excellent connectivity to IT hubs & metro. Schedule your site visit with Kolla Group." />
        <meta property="og:image" content="https://kollagroup.com/kollagrouplogo.png" />
        <meta property="og:site_name" content="Kolla Group" />
        <meta property="og:locale" content="en_IN" />

        <meta name="twitter:card" content="https://kollagroup.com/kollagrouplogo.png" />
        <meta name="twitter:url" content="https://kollagroup.com/" />
        <meta name="twitter:title" content="Kolla Group - Luxury Villas & Apartments in Hyderabad" />
        <meta name="twitter:description" content="Premium 3 BHK flats for sale in Chanda Nagar, Hyderabad. Excellent connectivity to IT hubs & metro. Schedule your site visit with Kolla Group." />
        <meta name="twitter:image" content="https://kollagroup.com/kollagrouplogo.png" />
        <link rel="preconnect" href="https://fonts.cdnfonts.com" />
        <link href="https://fonts.cdnfonts.com/css/lemon-milk" rel="stylesheet" />

        <link rel="icon" href="https://kollagroup.com/favicon.ico" />
        <link rel="apple-touch-icon" href="https://kollagroup.com/logo192.png" />
        <link rel="manifest" href="https://kollagroup.com/manifest.json" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Kolla Luxuria",
            "url": "https://www.kollagroup.com/",
            "description": "Premium 3 BHK flats for sale in Chanda Nagar, Hyderabad. Excellent connectivity to IT hubs & metro. Schedule your site visit with Kolla Group.",
            "publisher": {
              "@type": "Organization",
              "name": "Kolla Group",
              "logo": "https://www.kollagroup.com/favicon.ico"
            }
          })}
        </script>
      </Helmet>
      <div style={styles.blackOverlay}></div>
      <div style={styles.container}>
        <VideoSection />
        <AboutUsSection />
        <ProjectSliderSection />
        <BlogSection />
        <ContactSection />
        <ContactForm />
      </div>
    </div>
  );
};

export default DashboardPage;